import { z } from 'zod';
export const SessionTypeSchema = z.enum([
    'keynote',
    'talk',
    'panel',
    'fireside',
    'lightning',
    'workshop',
    'masterclass',
    'training',
    'demo',
    'roundtable',
    'breakout',
    'qa',
    'ceremony',
    'announcement',
    'exhibition',
    'networking',
    'reception',
    'party',
    'meal',
    'break',
    'other',
]);
export const TrackSchema = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid(),
    name: z.string(),
    color: z.string().nullable(),
    sortOrder: z.number().int(),
});
export const RoomSchema = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid(),
    name: z.string(),
    sortOrder: z.number().int(),
});
export const SessionSchema = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid(),
    trackId: z.string().uuid().nullable(),
    type: SessionTypeSchema,
    title: z.string(),
    description: z.string(),
    startAt: z.string(),
    endAt: z.string(),
    room: z.string().nullable(),
    capacity: z.number().int().positive().nullable(),
});
export const SpeakerSchema = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid(),
    name: z.string(),
    title: z.string().nullable(),
    company: z.string().nullable(),
    bio: z.string().nullable(),
    // An uploaded Storage path and a pasted URL are kept side by side; `photo` is
    // whichever the server decided to display (upload wins).
    photoPath: z.string().nullable(),
    photoUrl: z.string().nullable(),
    photo: z.string().nullable(),
    socialLinks: z.record(z.string()),
});
export const CreateTrackRequestSchema = z.object({
    name: z.string().min(1).max(100),
    color: z.string().nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const PatchTrackRequestSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    color: z.string().nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const CreateRoomRequestSchema = z.object({
    name: z.string().min(1).max(100),
    sortOrder: z.number().int().optional(),
});
export const PatchRoomRequestSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    sortOrder: z.number().int().optional(),
});
export const CreateSessionRequestSchema = z.object({
    trackId: z.string().uuid().nullable().optional(),
    type: SessionTypeSchema,
    title: z.string().min(1).max(200),
    description: z.string().max(5000).optional(),
    startAt: z.string(),
    endAt: z.string(),
    room: z.string().nullable().optional(),
    capacity: z.number().int().positive().nullable().optional(),
});
export const CreateSpeakerRequestSchema = z.object({
    name: z.string().min(1).max(200),
    title: z.string().nullable().optional(),
    company: z.string().nullable().optional(),
    bio: z.string().nullable().optional(),
    photoPath: z.string().nullable().optional(),
    photoUrl: z.string().url().nullable().optional(),
    socialLinks: z.record(z.string()).optional(),
});
//# sourceMappingURL=schedule.js.map